import { Link } from "react-router-dom";
import { Clock, Lock, Mail, LogOut, UserCog } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function EstablishmentLocked({ user }) {
    const { logout } = useAuth();
    const pending = user.establishment_status === "pending_activation";
    const Icon = pending ? Clock : Lock;
    return (
        <div className="min-h-screen bg-paper flex items-center justify-center px-6" data-testid="establishment-locked">
            <div className="panel p-10 max-w-xl w-full">
                <Icon size={34} className={pending ? "text-amber-600" : "text-destructive"} strokeWidth={1.5} />
                <div className="label-eyebrow mt-4">{pending ? "En attente d'activation" : "Accès suspendu"}</div>
                <h1 className="h-display text-3xl font-semibold mt-2" data-testid="establishment-locked-title">
                    {pending ? "Votre établissement n'est pas encore activé." : "L'accès de votre établissement est suspendu."}
                </h1>
                <p className="text-sm text-ink/70 mt-4 leading-relaxed" data-testid="establishment-locked-message">
                    {user.establishment_lock_message}
                </p>
                {pending && user.role === "responsable" && (
                    <p className="text-xs text-muted2 mt-3">
                        Le règlement s'effectue par virement bancaire sur facture. L'activation est faite manuellement par l'équipe Profawz dès réception.
                    </p>
                )}
                <div className="mt-8 flex flex-wrap gap-2">
                    <Link to="/account" className="btn-outline !text-xs" data-testid="locked-account-link">
                        <UserCog size={13} /> Mon compte et mes données
                    </Link>
                    <a href="mailto:contact@profawz.fr" className="btn-outline !text-xs" data-testid="locked-contact-link">
                        <Mail size={13} /> contact@profawz.fr
                    </a>
                    <button type="button" onClick={logout} className="btn-outline !text-xs" data-testid="locked-logout-button">
                        <LogOut size={13} /> Se déconnecter
                    </button>
                </div>
            </div>
        </div>
    );
}
